

































import {
    Component,
    Prop,
    Vue,
    Provide,
    Inject
} from "vue-property-decorator";
import TopicInfo from '@/components/Topic/TopicInfo.vue'
@Component({
    components: {
        TopicInfo,
    }
})
export default class TopicBlock extends Vue{
    @Prop(Array) data:any
    @Provide('only_show_owner')
    only_show_owner=false
    @Provide('is_notice')
    is_notice = false
    mounted(){
        let topic = this.data[0]
        let d  = new Date(Date.parse(topic.update_time.replace(/-/g,   "/")));
        this.is_notice = d>new Date()
    }

    do_only_show_owner(){
        this.only_show_owner = !this.only_show_owner
    }

    get get_data(){
        if (this.is_notice){
            return [this.data[0]]
        }
        if (this.only_show_owner){
            let p_user = this.data[0].user_id
            return this.data.filter(item=>{
                return item.user_id == p_user
            })
        }
        if (this.data.length<=30)
            return this.data
        else{
            let res= [this.data[0]].concat(this.data.slice(-29))
            return res
        }
    }
    do_only_show_last30(){

    }
}
